import AccountService from '@/services/AccountService';
import Loading from '@/components/widget/Loading';
export default {
  name: 'PasswordVerify',
  components: {
    Loading
  },
  props: {
    open: Boolean,
    request: Object
  },
  data() {
    return {
      loading: false,
      openModal: false,
      verified: false,
      pword: null,
      error: null
    };
  },
  methods: {
    confirmPassword(e) {
      if (e) {
        e.preventDefault();
      }
      if (this.loading || !this.pword) {
        return false;
      }
      this.loading = true;
      AccountService.verifyPassword({
        pword: this.pword,
        payload: this.request
      }).then(response => {
        if (response && response.data && response.data.success) {
          this.verified = true;
          this.loading = false;
          this.error = null;
          this.setPayload(response.data);
          setTimeout(() => {
            this.close();
          }, 500);
        } else {
          this.verified = false;
          this.loading = false;
          this.error = 'Failed to verify password!';
        }
      }).catch(error => {
        this.$aim.error(error.response);
        this.loading = false;
      });
    },
    setPayload(info) {
      this.$emit('payload', info);
    },
    close() {
      this.$nextTick(() => {
        this.$bvModal.hide('password-verify-modal');
      });
    }
  },
  watch: {
    verified() {
      this.$emit('verified', this.verified);
    },
    open() {
      this.openModal = this.open;
    }
  }
};